import React, { useEffect, useState, useRef} from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Board from './Board';
import "./Game.scss"
import countdownSound from './../../PhotoTime/count_down_beep.m4a';
import presentSound from "./../../Unit1/Module1/assets/ta_da_gift.mp3"
import tryAgainSound from './../../Unit1/Module1/assets/try_again.mp3'
import { ButtonWithSound } from './../Button/Button';



function Game(props) {
  
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    const { freeplay } = useSelector((state) => state.freeplay, shallowEqual);
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const [displayGame, setDisplayGame] = useState(true);
    const [displayReward, setDisplayReward] = useState(false);
    const [displayPenalty, setDisplayPenalty] = useState(false);


    const [spins, setSpins] = useState(100);
    const [position, setPosition] = useState(-1);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isStopping, setIsStopping] = useState(false);
    const [stop, setStop] = useState(false);
    const [boardItems, setBoardItems] = useState([]);
    const [coins, setCoins] = useState(props.coin);
    const [rewardAnimationState, setRewardAnimationState] = useState('');
    const [coinAudio, setCoinAudio] = useState(false);
    
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;
    function sleep(ms) {return new Promise((resolve) => setTimeout(resolve, ms));}

    const coin = generateImageUrl('images/Images/Coin_Empty.png');
    const coinPick = generateImageUrl('images/Images/AwesomeCoin.png');
    const audioRef = useRef(null); // Using a ref to store the audio instance

    const shuffleArray = (array) => {
      let currentIndex = array.length, randomIndex;
    
      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
    
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
    
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }
    
      return array;
    };
  
    const initialBoardItems = [
      { value: 1, type: 'coin' },
      { value: 2, type: 'coin' },
      { value: 3, type: 'coin' },
      { value: 4, type: 'coin' },
      { value: 3, type: 'coin' },
      { value: 1, type: 'coin' },
      { value: 1, type: 'coin' },
      { value: 1, type: 'coin' },
      { value: 1, type: 'coin' },
      { value: generateImageUrl('images/Module11Images/CharacterScene_Crab_Sad@2x.png'), type: 'whammy', action: "-1" },
      { value: 2, type: 'coin' },
      { value: 2, type: 'coin' },
      { value: 1, type: 'coin' },
      { value: generateImageUrl('images/Module11Images/CharacterScene_Crab_Mad@2x.png'), type: 'whammy', action: "respin" },
      { value: 2, type: 'coin' },
      { value: generateImageUrl('images/Module11Images/CharacterScene_Crab_Mad@2x.png'), type: 'whammy', action: "respin" },
    ];
    
    useEffect(() => {
      setBoardItems(shuffleArray([...initialBoardItems]));
    }, []);

    const intervalRef = useRef(null);

    const startSpinning = () => {
      if (spins > 0 && !isSpinning) {
        setIsSpinning(true);
        intervalRef.current = setInterval(() => {
          setPosition((prev) => (prev + 1) % 16);
        }, 50);
      }
    };
  
    const stopSpinning = () => {
      if (isSpinning && !isStopping) {
        setIsStopping(true);
        clearInterval(intervalRef.current);
        let extraSpins = 0;
        const extraMoves = 3; // Number of extra moves after stopping
        let currentPosition = position;
        audioRef.current = new Audio(countdownSound);
        audioRef.current.preload = 'auto';

        const slowSpin = () => {
          audioRef.current.play();
          currentPosition = (currentPosition + 1) % 16;
          setPosition(currentPosition);
          extraSpins++;
          if (extraSpins >= extraMoves) {
            setSpins(spins - 1);
            setIsSpinning(false);
            setIsStopping(false);
            setPosition(currentPosition);
            if(boardItems[currentPosition].type === 'coin') {
              audioRef.current = new Audio(presentSound);
              audioRef.current.preload = 'auto';
              setStop(true)
              sleep(1000).then(() => {
                setDisplayGame(false);
                audioRef.current.play();
                setDisplayReward(true);
              });
            }
            else{
              audioRef.current = new Audio(generateImageUrl("media/Module2Videos/ah_oh.mp3"));
              audioRef.current.preload = 'auto';
              if(boardItems[currentPosition].action === '-1'){
                setStop(true)
                sleep(1000).then(() => {
                  setDisplayGame(false);
                  setRewardAnimationState('looseCoinAnimation');
                  setCoinAudio(true);
                  sleep(2000).then(() => {
                    setCoins(props.coin - 1)
                  });
                  audioRef.current.play();
                  setDisplayPenalty(true);
                });
              }
              else{     
                sleep(500).then(() => {
                  const taSound = new Audio(tryAgainSound);
                  audioRef.current.onended = () => taSound.play();
                  audioRef.current.play();
                });
              }
            }
          } else {
            setTimeout(slowSpin, 200 + (extraSpins * 100)); // Increase delay for each extra spin
          }
        };
        slowSpin();
      }
    };
  
    return (
      <div className="press_your_luck">
        <header>
            <div className='actions'>
            </div>            
            <div className='coins'>
                <img src={coin} alt='crab Icon'/>
                {coins < 10 && <div className='coin1'>{coins}</div>}
                {coins >= 10 && coins < 100 && <div className='coin10'>{coins}</div>}
                {coins >= 100 && <div className='coin100'>{coins}</div>}
            </div>
        </header>
        {displayGame && <div className='gameBody'>
          <Board position={position} isSpinning={isSpinning} boardItems={boardItems} coinImg={coin} startSpinning={startSpinning} stopSpinning={stopSpinning} stop={stop}/>
        </div>}
        {displayReward && <div className='rewardBody'>
          {coinAudio && (
              <audio
                  autoPlay
                  onEnded={() => {
                  dispatch({ type: `FREEPLAY_SET_${props.level}_COIN`, payload: props.coin + boardItems[position].value });
                  if(props.level === 'LEVEL2'){
                    dispatch({ type: `FREEPLAY_SET_LEVEL2_SHAREDCOIN`, payload: freeplay.level2SharedCoin + boardItems[position].value });
                  }
                  if(props.level === 'LEVEL3'){
                    dispatch({ type: `FREEPLAY_SET_LEVEL3_SHAREDCOIN`, payload: freeplay.level3SharedCoin + boardItems[position].value });
                  }
                  if(props.level === 'LEVEL4'){
                    dispatch({ type: `FREEPLAY_SET_LEVEL4_SHAREDCOIN`, payload: freeplay.level4SharedCoin + boardItems[position].value });
                  }
                  props.checkCompletion();
              }}>
                  <source src={generateImageUrl('media/Module5Videos/earn_token.mp3')} type='audio/mp3'/>
              </audio>
          )}
          <div className='starburst'> 
            <img
                id={rewardAnimationState}
                src={coinPick}
                alt='reward key'
                className='reward'
            />
            {!coinAudio && <h1>{boardItems[position].value}</h1>}
          </div>
          <div className='you-won-text'> <span>YOU WON!</span></div>
          {!coinAudio && <button className="claim" 
            onClick={() => {
              setRewardAnimationState('coinAnimation');
              setCoinAudio(true);
              sleep(2000).then(() => {
                setCoins(props.coin + boardItems[position].value)
              });
            }}
            disabled={coinAudio}
          > 
            Claim
          </button>}
        </div>}
        {displayPenalty && <div className='rewardBody'>
          {coinAudio && (
              <audio
                  autoPlay
                  onEnded={() => {
                    dispatch({ type: `FREEPLAY_SET_${props.level}_COIN`, payload: props.coin - 1 });
                    if(props.level === 'LEVEL2'){
                      dispatch({ type: `FREEPLAY_SET_LEVEL2_SHAREDCOIN`, payload: freeplay.level2SharedCoin - 1 });
                    }
                    if(props.level === 'LEVEL3'){
                      dispatch({ type: `FREEPLAY_SET_LEVEL3_SHAREDCOIN`, payload: freeplay.level3SharedCoin - 1 });
                    }
                    if(props.level === 'LEVEL4'){
                      dispatch({ type: `FREEPLAY_SET_LEVEL4_SHAREDCOIN`, payload: freeplay.level4SharedCoin - 1 });
                    }
              }}>
                  <source src={generateImageUrl('media/Module5Videos/earn_token.mp3')} type='audio/mp3'/>
              </audio>
          )}
          <div className='starburst'> 
            <img
                id={rewardAnimationState}
                src={coinPick}
                alt='reward key'
                className='reward'
            />
            {rewardAnimationState === 'looseCoinAnimation' && <h1>-1</h1>}
            </div>
          <div className='you-won-text'> <span>YOU LOST!</span></div>
          <ButtonWithSound button={true} className="claim" onClick={() => {props.checkCompletion();}} label={"Continue"}/> 
        </div>}
      </div>
    );
  }

export default Game;